import React from 'react';
import i18n from 'i18next'; import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as pageActions from 'actions/pageActions';
import * as surveyActions from 'actions/surveyActions';
import * as timerActions from 'actions/timerActions';
import withRequestErrors, { withRequestErrorsPropTypes } from 'components/HOC/withRequestErrors';
import { parseErrorMessage } from 'utils/index';
import { OWNER } from 'constants/users';
import { WELCOME, MOTIVATOR } from 'constants/pageDictionary';
import CompanyDateQuestion from './CompanyDateQuestion';
import AgeQuestion from './AgeQuestion';
import GenderQuestion from './GenderQuestion';
import QuestionHeader from './QuestionHeader';
import BackNextFooter from './BackNextFooter';
import './styles.scss';

class PreliminaryQuestions extends React.Component {
    constructor(props) {
        super(props);
        const defaultQuestionIdx = props.pageProps && props.pageProps.currentQuestionIdx;
        this.state = {
            joinYear: {},
            joinMonth: {},
            age: {},
            gender: {},
            currentQuestionIdx: defaultQuestionIdx || 0,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className='preliminary-questions-container'>
                <div className='content'>
                    <QuestionHeader question={ this.getQuestion() } />
                    {this.renderQuestion()}
                    <p className='errors'>{this.state.errors.message}</p>
                    <BackNextFooter
                        onBack={ this.getOnBack() }
                        onNext={ this.getOnNext() }
                        isRequesting={ this.props.isRequesting } />
                </div>
            </div>
        );
    }

    onStartAssessment = async () => {
        await this.props.enhanceWithRequestErrors(this.props.actions.startSurvey)();
        this.props.actions.startTimer(new Date());
        this.props.actions.goToPage(MOTIVATOR);
    };

    updateAnswers = (key, value) => {
        this.setState({ [key]: value });
    }


    renderQuestion = () => {
        switch (this.state.currentQuestionIdx) {
        case 0:
            return (<CompanyDateQuestion
                languageId={ this.props.user.get('languageId') }
                updateAnswers={ this.updateAnswers }
                joinYear={ this.state.joinYear }
                joinMonth={ this.state.joinMonth } />);
        case 1:
            return (<AgeQuestion
                languageId={ this.props.user.get('languageId') }
                updateAnswers={ this.updateAnswers }
                age={ this.state.age }
                ages={ this.props.ages ? this.props.ages.toJS() : [] } />);
        case 2:
            return (<GenderQuestion
                languageId={ this.props.user.get('languageId') }
                updateAnswers={ this.updateAnswers }
                gender={ this.state.gender }
                genders={ this.props.genders ? this.props.genders.toJS() : [] } />);
        default:
            return null;
        }
    }

    getQuestion = () => {
        switch (this.state.currentQuestionIdx) {
        case 0:
            return i18n.t('motivator.please_let_us_know_date_join_company');
        case 1:
            return i18n.t('motivator.please_let_us_know_your_age');
        case 2:
            return i18n.t('motivator.please_let_us_know_your_gender');
        default:
            return null;
        }
    }

    getOnBack = () => {
        switch (this.state.currentQuestionIdx) {
        case 0:
            return () => this.props.actions.goToPage(WELCOME);
        case 1:
            return () => this.getNextQuestion({ questionIdx: this.state.currentQuestionIdx - 1, direction: -1 });
        case 2:
            return () => this.getNextQuestion({ questionIdx: this.state.currentQuestionIdx - 1, direction: -1 });
        default:
            return null;
        }
    }

    getOnNext = () => {
        switch (this.state.currentQuestionIdx) {
        case 0:
            if (this.state.joinMonth.value === undefined ||
                this.state.joinYear.value === undefined ||
                (!this.state.joinMonth.value && this.state.joinYear.value) ||
                (this.state.joinMonth.value && !this.state.joinYear.value)) return null;
            return async () => {
                try {
                    await this.props.enhanceWithRequestErrors(this.props.actions.updateRespondent)({
                        respondent_id: this.props.user.get('respondentId'),
                        respondent_tenure_year: (this.state.joinMonth.value && this.state.joinYear.value) || null,
                        respondent_tenure_month: (this.state.joinYear.value && this.state.joinMonth.value) || null
                    });
                    this.getNextQuestion({ questionIdx: this.state.currentQuestionIdx + 1, direction: 1 });
                } catch (errors) {
                    this.setState({ errors: parseErrorMessage(errors) });
                }
            };
        case 1:
            if (!this.state.age.id && !this.state.age.value) return null;
            return async () => {
                try {
                    const defaultAnswer = this.props.ages.toJS() && this.props.ages.toJS().slice(-1)[0].id;
                    await this.props.enhanceWithRequestErrors(this.props.actions.updateRespondent)({
                        respondent_id: this.props.user.get('respondentId'),
                        respondent_age_id: this.state.age.id || this.state.age.value || defaultAnswer

                    });
                    this.getNextQuestion({ questionIdx: this.state.currentQuestionIdx + 1, direction: 1 });
                } catch (errors) {
                    this.setState({ errors: parseErrorMessage(errors) });
                }
            };
        case 2:
            if (!this.state.gender.id && !this.state.gender.value) return null;
            return async () => {
                try {
                    const defaultAnswer = this.props.genders.toJS() && this.props.genders.toJS().slice(-1)[0].id;
                    await this.props.enhanceWithRequestErrors(this.props.actions.updateRespondent)({
                        respondent_id: this.props.user.get('respondentId'),
                        respondent_gender_id: this.state.gender.id || this.state.gender.value || defaultAnswer

                    });
                    this.onStartAssessment();
                } catch (errors) {
                    this.setState({ errors: parseErrorMessage(errors) });
                }
            };
        default:
            return null;
        }
    }

    getNextQuestion = ({ questionIdx, direction }) => {
        const isOwner = this.props.user.get('userRole') === OWNER;
        switch (questionIdx) {
        case 0:
            if (!isOwner && !this.props.surveyOptions.get('ask_respondent_tenure')) {
                this.getNextQuestion({ questionIdx: questionIdx + direction, direction });
            } else if (this.state.currentQuestionIdx !== questionIdx) {
                this.setState({ currentQuestionIdx: questionIdx, errors: {} });
            }
            break;
        case 1:
            if (!isOwner && !this.props.surveyOptions.get('ask_respondent_age')) {
                this.getNextQuestion({ questionIdx: questionIdx + direction, direction });
            } else if (this.state.currentQuestionIdx !== questionIdx) {
                this.setState({ currentQuestionIdx: questionIdx, errors: {} });
            }
            break;
        case 2:
            if (!isOwner && !this.props.surveyOptions.get('ask_respondent_gender')) {
                this.onStartAssessment();
            } else if (this.state.currentQuestionIdx !== questionIdx) {
                this.setState({ currentQuestionIdx: questionIdx, errors: {} });
            }
            break;
        default:
            this.props.actions.goToPage(WELCOME);
            break;
        }
    }
}

PreliminaryQuestions.propTypes = {
    user: PropTypes.object,
    ages: PropTypes.object,
    genders: PropTypes.object,
    isRequesting: PropTypes.bool,
    surveyOptions: PropTypes.object,
    pageProps: PropTypes.object,
    ...withRequestErrorsPropTypes

};

PreliminaryQuestions.defaultProps = {
    surveyOptions: {},
    user: null,
    ages: null,
    genders: null,
    isRequesting: false,
    pageProps: {}
};

const mapStateToProps = (state) => ({
    pageProps: state.pageReducer.get('pageProps'),
    surveyOptions: state.surveyOptionsReducer,
    genders: state.preliminaryOptionsReducer.get('genders'),
    ages: state.preliminaryOptionsReducer.get('ages'),
    user: state.respondentNameReducer
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign({}, pageActions, surveyActions, timerActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRequestErrors(PreliminaryQuestions));

